import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import LoadingButton from 'components/LoadingButton'

import { create, update, themeName, cancel, save } from './locale'
import Styles from './styles.scss'


export default function ThemeSaver({ loading, mode, field, onCancel, onSave }) {
  const cancelClassName = classnames(Styles.cancelButton, 't-cancelThemeButton')

  return (
    <div className={ Styles.wrapper }>
      <div className={ Styles.title }>
        <FormattedMessage { ...(mode === 'create' ? create : update) } />
      </div>
      <div className={ Styles.label }>
        <FormattedMessage { ...themeName } />
      </div>
      <div className={ Styles.field }>
        <Field { ...field } />
      </div>
      <div className={ Styles.buttonsWrapper }>
        <div
          className={ cancelClassName }
          onClick={ onCancel }
        >
          <FormattedMessage { ...cancel } />
        </div>
        <LoadingButton
          className="t-saveThemeButton"
          color="secondary"
          disabled={ loading }
          handleClick={ onSave }
          isLoading={ loading }
          type="solid"
        >
          <FormattedMessage
            { ...save }
          />
        </LoadingButton>
      </div>
    </div>
  )
}

ThemeSaver.propTypes = {
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['create', 'update']),
  field: PropTypes.shape({ ...Field.propTypes }),
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
}

ThemeSaver.defaultProps = {
  loading: true,
  mode: 'create',
  field: {},
  onCancel: null,
  onSave: null,
}
